export default __webpack_public_path__ + "static/media/Sanjay.581d3977.png";